"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAccessColumnName = void 0;
var UserAccessColumnName;
(function (UserAccessColumnName) {
    UserAccessColumnName["ArrearsAccessFlag"] = "ArrearsAccessFlag";
    UserAccessColumnName["ArrearsRoleCode"] = "ArrearsRoleCode";
    UserAccessColumnName["ClaimAccessFlag"] = "ClaimAccessFlag";
    UserAccessColumnName["ClaimRoleCode"] = "ClaimRoleCode";
    UserAccessColumnName["DefaultAccessFlag"] = "DefaultAccessFlag";
    UserAccessColumnName["DefaultRoleCode"] = "DefaultRoleCode";
    UserAccessColumnName["PIFileShareAccessFlag"] = "PIFileShareAccessFlag";
    UserAccessColumnName["PIFileShareRoleCode"] = "PIFileShareRoleCode";
    UserAccessColumnName["PIPurposeTestAccessFlag"] = "PIPurposeTestAccessFlag";
    UserAccessColumnName["PIPurposeTestRoleCode"] = "PIPurposeTestRoleCode";
    UserAccessColumnName["PIRequestAccessFlag"] = "PIRequestAccessFlag";
    UserAccessColumnName["PIRequestRoleCode"] = "PIRequestRoleCode";
    UserAccessColumnName["DefaultFinancialInstitutionCodeAndTransitNumber"] = "DefaultFinancialInstitutionCodeAndTransitNumber";
    UserAccessColumnName["LenderRoleCode"] = "LenderRoleCode";
    UserAccessColumnName["StatusCode"] = "StatusCode";
})(UserAccessColumnName = exports.UserAccessColumnName || (exports.UserAccessColumnName = {}));
